import { Dispatch } from 'redux';
import { action } from 'typesafe-actions';
import { currentWorkgroupKey, getCookieValue } from '../../utils/ajax';
import { transformBackendData } from '../../utils/treeTransform';
import { ActionTypes, MediaItem, TreeItem } from '../types';

export function fetchDataAsync(parentMediaId: number) {
  return (dispatch: Dispatch<any>) => {
    dispatch(fetchMediasRequest());
    const HEADER_NAME: string = process.env.REACT_APP_HEADER_01 as string;

    Promise.all([
      fetch(process.env.REACT_APP_ROOT_DOMAIN + `v6/media/timelineMediaInfo/${parentMediaId}`, {
        headers: {
          [HEADER_NAME]: getCookieValue(currentWorkgroupKey)
        }
      }).then(res => res.json()),
      fetch(process.env.REACT_APP_ROOT_DOMAIN + `v6/media/timelineMediaTree/${parentMediaId}`, {
        headers: {
          [HEADER_NAME]: getCookieValue(currentWorkgroupKey)
        }
      }).then(res => res.json())
    ])
      .then(data => {
        const [medias, tree] = data;
        const payload = transformBackendData(parentMediaId, medias, tree);
        dispatch(fetchMediasSuccess(payload));
      })
      .catch(error => dispatch(fetchMediasError(error)));
  };
}

export const fetchMediasRequest = () => action(ActionTypes.FETCH_MEDIAS_REQUEST);
export const fetchMediasSuccess = (data: { medias: { [id: number]: MediaItem }; tree: TreeItem[] }) =>
  action(ActionTypes.FETCH_MEDIAS_SUCCESS, data);
export const fetchMediasError = (message: string) => action(ActionTypes.FETCH_MEDIAS_ERROR, message);
export const expand = (treeId: string) => action(ActionTypes.EXPAND, treeId);
export const collapse = (treeId: string) => action(ActionTypes.COLLAPSE, treeId);



// WEBPACK FOOTER //
// ./src/store/actions/mediaActions.ts